// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export let environment = {
  production: false,
  loginTimeout: 7260000, //2h
  lockTimeout: 7200000,  //2h
  NotificationTime: 7160000, //56m
  // 3600000 - 1h, 900000 - 15min //86400000 - 24h //  60000 ~ 1m // 30000 ~ 30sec to test it
  // loginTimeout: 90000,
  // lockTimeout: 30000,
  // NotificationTime: 15000 ,
  DevelopProject: '',
  
  //SocketURL: 'http://localhost:5005',
  SecureSocketURL: 'https://socket.parco.com.cy',
  SocketURL: 'http://socket.app.cspcom.com',

  //TODO : Can Be Split Later on
  authURL: 'https://auth.parco.com.cy',
  app_apiURL: 'https://auth.parco.com.cy',

  //Not Implemented Dynamic Per Project apiURL
  prj_apiURL: 'https://api.parco.com.cy',  //under development

  ims_apiURL: 'http://ims.api.cspcom.com',
  ifs_apiURL: 'http://ifs.api.cspcom.com',
  insure_apiURL: 'http://insure.api.cspcom.com',
  betx_apiURL: 'http://betx.api.cspcom.com',
  // ac_apiURL: 'http://ac.api.cspcom.com', //NOT IMPLEMENTED YET
  cpp_apiURL: 'http://cpp.api.cspcom.com',
  epos_apiURL: 'https://api.parco.com.cy',
  rl_apiURL: 'https://auth.parco.com.cy/accidentcare/WebService.asmx',

  appauditors_apiURL: 'https://api.appadvisory.eu',

};
